export function getStaticMeta(page, language = 'fr') {
  const isFr = !String(language).startsWith('en');

  const pages = {
    home: {
      title: isFr
        ? 'Alturion Labs — Indicateurs premium pour NinjaTrader 8'
        : 'Alturion Labs — Premium indicators for NinjaTrader 8',
      description: isFr
        ? 'Indicateurs NinjaTrader 8 pour le volume, le VWAP et les niveaux de session. Installation guidée, mises à jour et support inclus.'
        : 'NinjaTrader 8 indicators for volume, VWAP and session levels. Guided installation, updates and support included.',
    },
    indicators: {
      title: isFr
        ? 'Indicateurs NinjaTrader 8 — Volume, VWAP, sessions | Alturion Labs'
        : 'NinjaTrader 8 indicators — Volume, VWAP, sessions | Alturion Labs',
      description: isFr
        ? 'Catalogue d’indicateurs Alturion Labs pour NinjaTrader 8 : Volume Profile, VWAP, sessions et outils d’analyse.'
        : 'Alturion Labs indicator catalog for NinjaTrader 8: Volume Profile, VWAP, sessions and analysis tools.',
    },
    free: {
      title: isFr
        ? 'Indicateurs NinjaTrader 8 gratuits | Alturion Labs'
        : 'Free NinjaTrader 8 indicators | Alturion Labs',
      description: isFr
        ? 'Téléchargez des indicateurs NinjaTrader 8 gratuits Alturion Labs, sans engagement.'
        : 'Download free Alturion Labs NinjaTrader 8 indicators, with no commitment.',
    },
    resources: {
      title: isFr
        ? 'Ressources trading NinjaTrader | Alturion Labs'
        : 'NinjaTrader trading resources | Alturion Labs',
      description: isFr
        ? 'Guides VWAP, Volume Profile, sessions, ORB et risque prop pour traders NinjaTrader 8.'
        : 'VWAP, Volume Profile, sessions, ORB and prop-risk guides for NinjaTrader 8 traders.',
    },
    ninjatrader: {
      title: isFr
        ? 'NinjaTrader 8 — Plateforme et indicateurs | Alturion Labs'
        : 'NinjaTrader 8 — Platform and indicators | Alturion Labs',
      description: isFr
        ? 'Découvrez NinjaTrader 8 et les indicateurs Alturion Labs conçus pour cette plateforme.'
        : 'Discover NinjaTrader 8 and Alturion Labs indicators built for the platform.',
    },
    support: {
      title: isFr
        ? 'Support | Alturion Labs'
        : 'Support | Alturion Labs',
      description: isFr
        ? 'Contactez le support Alturion Labs pour l’installation, les licences et l’utilisation des indicateurs NinjaTrader 8.'
        : 'Contact Alturion Labs support for installation, licenses and NinjaTrader 8 indicator help.',
    },
    legal: {
      title: isFr ? 'Mentions légales | Alturion Labs' : 'Legal notice | Alturion Labs',
      description: isFr
        ? 'Mentions légales du site Alturion Labs, édité par Samy Bidar, entrepreneur individuel.'
        : 'Legal notice for the Alturion Labs website, published by Samy Bidar, sole trader.',
    },
    privacy: {
      title: isFr ? 'Politique de confidentialité | Alturion Labs' : 'Privacy policy | Alturion Labs',
      description: isFr
        ? 'Politique de confidentialité et traitement des données personnelles d’Alturion Labs.'
        : 'Alturion Labs privacy policy and personal data processing.',
    },
    terms: {
      title: isFr ? 'Conditions générales de vente | Alturion Labs' : 'Terms of sale | Alturion Labs',
      description: isFr
        ? 'CGV Alturion Labs : vente d’indicateurs NinjaTrader 8, essai 7 jours, franchise en base de TVA.'
        : 'Alturion Labs terms of sale for NinjaTrader 8 indicators, 7-day trial, VAT franchise.',
    },
    cookies: {
      title: isFr ? 'Politique de cookies | Alturion Labs' : 'Cookie policy | Alturion Labs',
      description: isFr
        ? 'Politique de cookies du site Alturion Labs.'
        : 'Cookie policy for the Alturion Labs website.',
    },
    refund: {
      title: isFr ? 'Politique de remboursement | Alturion Labs' : 'Refund policy | Alturion Labs',
      description: isFr
        ? 'Conditions de remboursement des indicateurs Alturion Labs pour NinjaTrader 8.'
        : 'Refund conditions for Alturion Labs NinjaTrader 8 indicators.',
    },
    disclosure: {
      title: isFr ? 'Avertissements | Alturion Labs' : 'Disclosures | Alturion Labs',
      description: isFr
        ? 'Avertissements sur les risques liés au trading. Les indicateurs Alturion Labs n’offrent aucune garantie de performance.'
        : 'Trading risk disclosures. Alturion Labs indicators do not guarantee performance.',
    },
  };

  return pages[page] || pages.home;
}

export function getProductMeta(name, description, language = 'fr') {
  const isFr = !String(language).startsWith('en');
  const productName = name || (isFr ? 'Indicateur' : 'Indicator');
  const fallback = isFr
    ? `${productName} pour NinjaTrader 8, développé par Alturion Labs.`
    : `${productName} for NinjaTrader 8, developed by Alturion Labs.`;
  const desc = (description || fallback).replace(/\s+/g, ' ').trim().slice(0, 160);

  return {
    title: `${productName} | Alturion Labs`,
    description: desc,
  };
}

export function getArticleMeta(title, description, language = 'fr') {
  const isFr = !String(language).startsWith('en');
  const fallback = isFr
    ? 'Guide Alturion Labs pour traders NinjaTrader 8.'
    : 'Alturion Labs guide for NinjaTrader 8 traders.';
  const desc = (description || fallback).replace(/\s+/g, ' ').trim().slice(0, 160);

  return {
    title: `${title} | Alturion Labs`,
    description: desc,
  };
}
